
import { initialState, BP_Status } from '../state';
import { ExecutedPathActions, ExecutedPathActionTypes } from '../actions';

export function executionHistoryParsingStatus(state = initialState.executionHistoryParsingStatus, action: ExecutedPathActions): BP_Status {
  switch (action.type) {
    case ExecutedPathActionTypes.UPDATE_EXECUTION_HISTORY_PARSING_STATUS: {
      return action.payload.status;
    }
    case ExecutedPathActionTypes.CLEAR_EXECUTION_HISTORY: {
      return BP_Status.NotStarted;
    }
    case ExecutedPathActionTypes.CLEAR_ITEMS_TO_SELECT: {
      return BP_Status.NotStarted;
    }
    default: {
      return state;
    }
  }
}
